"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function textRotation(shape, option) {
    shape.resetMatrix();
    shape.attr({
        rotate: 360 - option.degree,
        textAlign: 'right',
        textBaseline: 'middle',
    });
}
exports.default = textRotation;
//# sourceMappingURL=text-rotation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/rules/text-rotation.js
// module id = 1039
// module chunks = 37